"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.Timeline = void 0;
var _react = _interopRequireWildcard(require("react"));
var _Icon = require("../../Elements/Icon/Icon");
var _Badge = _interopRequireDefault(require("../../Containers/Badge/Badge"));
var _FormattedDate = require("../../Elements/FormattedComposite/FormattedDate");
var _Text = require("../../Elements/Text/Text");
var _jsxRuntime = require("react/jsx-runtime");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
/* eslint-disable import/prefer-default-export */
/* eslint react/forbid-prop-types: 0 */

const Timeline = props => {
  const {
    config,
    labels,
    data
  } = props;
  const [cancleStages, setCancleStages] = (0, _react.useState)(JSON.parse(JSON.stringify(config.flow[0].stages)));
  const {
    flow,
    dateConfig
  } = config;
  const [stagesList, setStagesList] = (0, _react.useState)(JSON.parse(JSON.stringify(flow[0].stages)));
  const currentStagesList = () => {
    if (data.stage.main !== 'cancelled' && stagesList.findIndex(o => o.id === 'cancelled') != -1) {
      const cancelledIndex = stagesList.findIndex(o => o.id === 'cancelled');
      stagesList.splice(cancelledIndex);
      setStagesList(stagesList);
    }
    if (data.stage.main === 'cancelled' && stagesList.findIndex(o => o.id === 'cancelled') === -1) {
      setStagesList(cancleStages);
    }
  };
  currentStagesList();
  const activeItem = stagesList.findIndex(x => x.id == data.stage.main);
  const getItemClass = index => {
    var _stagesList, _stagesList$activeIte, _stagesList2;
    let itemClass = '';
    let currentId = stagesList[index].id;
    let nextId = (_stagesList = stagesList[index + 1]) == null ? void 0 : _stagesList.id;

    // if it is a cancelled timeline
    if (((_stagesList$activeIte = stagesList[activeItem]) == null ? void 0 : _stagesList$activeIte.id) == 'cancelled') {
      if (data.date[currentId] && data.date[nextId] && currentId !== 'cancelled') {
        return itemClass = 'active';
      } else if (currentId === 'cancelled') {
        return itemClass = 'cancel';
      } else {
        return itemClass = 'disabled ';
      }
    }

    /**  if active milestone not cancelled and
     *  its index > the current index,
     * then the current milestone is green*/
    if (activeItem > index && !(data.stage.main == 'cancelled')) {
      itemClass = 'active';
    }

    /**  if the date list has closed data
     * then the current timeline is done*/
    if (data.date.closed) {
      itemClass = 'done';
    }

    /**  if the date list haven't closed data
     * and also not a cancelled timeline
     * when  current index == active milestone index and active milestone index  < timeline 's length-1
     * then the current milestone is pending*/

    /**  Or the previous step has the id name of the main stage */
    /* But not when we are talking about the last item */
    if (!data.date.closed && activeItem === index && activeItem < stagesList.length - 1 && !(data.stage.main == 'cancelled') || !data.date.closed && data.stage.main === ((_stagesList2 = stagesList[index - 1]) == null ? void 0 : _stagesList2.id) && stagesList.length - 1 !== index && flow[0].name === 'sale' && !(data.stage.main == 'cancelled')) {
      itemClass = 'pending';
    }

    // if have date it style is green
    // and stage is not the same as previous phase (for sale order)
    if (flow[0].name === 'sale') {
      var _stagesList3;
      let currentItemId = stagesList[index].id;
      if (data.date[currentItemId] && data.stage.main !== ((_stagesList3 = stagesList[index - 1]) == null ? void 0 : _stagesList3.id)) {
        itemClass = 'active';
      }
    }

    // if have date it style is green
    // make sure that last item is green when shipped
    if (flow[0].name === 'insurance') {
      var _stagesList4;
      let currentItemId = stagesList[index].id;
      if (data.date[currentItemId] && data.stage.main === ((_stagesList4 = stagesList[stagesList.length - 1]) == null ? void 0 : _stagesList4.id)) {
        itemClass = 'active';
      }
    }

    // if (
    //   activeItem === 0 &&
    //   index === 0 &&
    //   !(data.stage.main == 'cancelled')
    // ) {
    //   itemClass = 'active createOnly';
    // }

    if (stagesList.length - 1 === index) {
      // last item on the list
      itemClass += ' item--last-item';
    }
    return itemClass;
  };
  const getSubItemClass = (item, subitem, index, sIndex) => {
    let subItemClass = '';

    /**  if active submilestone 's index > current submilestone 's index 
    then current submilestone 's status is pending and display*/
    if (item.stages.findIndex(x => x.id == data.stage.sub) >= sIndex) {
      subItemClass = 'active';
    }
    if (subitem.id === data.stage.sub) {
      subItemClass = 'active';
    }
    if (activeItem - 1 === index) {
      subItemClass = 'active';
    }

    // if datelist have submilestone 's date the current submilestone is green
    if (data.date[subitem.id]) {
      subItemClass = 'active done';
    }

    // if only one subitem show
    if (item.stages.length == 1 || item.stages.findIndex(x => x.id == data.stage.sub) == sIndex && sIndex == 0) {
      subItemClass += ' oneSubitem';
    }

    // if it is a cancelled timeline the submilestone is disabled
    if (stagesList[activeItem].id == 'cancelled') {
      subItemClass = 'disabled';
    }
    return subItemClass;
  };
  const formattedDate = date => {
    return date ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_FormattedDate.FormattedDate, {
      config: {
        country: dateConfig.country,
        language: dateConfig.language,
        mask: dateConfig.mask
      },
      data: date
    }) : '';
  };
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
    className: "ccl-e-timeline",
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)("ul", {
      className: `ccl-e-timeline__container__list-items `,
      children: stagesList == null ? void 0 : stagesList.map((item, index) => {
        var _item$notes, _item$stages;
        return /*#__PURE__*/(0, _jsxRuntime.jsxs)("li", {
          className: `ccl-e-timeline__container__list-items__item
              ${getItemClass(index)}
              `,
          children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_Icon.Icon, {
            className: `ccl-e-timeline__icon ccl-e-timeline__icon__active `,
            type: "check-circle--filled",
            size: "lg"
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
            className: `ccl-e-timeline__icon ccl-e-timeline__icon__pending`
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
            className: `ccl-e-timeline__icon ccl-e-timeline__icon__cancel`,
            children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Icon.Icon, {
              color: "inverse",
              size: "xs",
              type: "clear"
            })
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
            className: `ccl-e-timeline__dot`
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
            className: `ccl-e-timeline__item-date`,
            children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Badge.default, {
              children: formattedDate(data == null ? void 0 : data.date[item.id])
            })
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)("p", {
            className: "ccl-e-timeline__item-title",
            children: labels[item == null ? void 0 : item.label]
          }), (_item$notes = item.notes) == null ? void 0 : _item$notes.map((note, nIndex) => {
            return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
              className: `ccl-e-timeline__item__container-note 
                    ${item.notes.findIndex(x => x.id == data.stage.sub) >= nIndex ? 'active' : ''}
                    ${activeItem - 1 == index && !data.date.closed ? 'active' : ''}
                    `,
              children: [(note == null ? void 0 : note.content) && /*#__PURE__*/(0, _jsxRuntime.jsx)(_Text.Text, {
                className: `ccl-e-timeline__item-note`,
                type: "body-text",
                isHTML: true,
                content: JSON.parse(note == null ? void 0 : note.content)
              }, nIndex), /*#__PURE__*/(0, _jsxRuntime.jsx)(_Badge.default, {
                children: formattedDate(data == null ? void 0 : data.date[note.id])
              })]
            }, note.id || note.content);
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)("ul", {
            children: activeItem <= index + 1 && ((_item$stages = item.stages) == null ? void 0 : _item$stages.map((subitem, sIndex) => {
              return /*#__PURE__*/(0, _jsxRuntime.jsxs)("li", {
                className: `ccl-e-timeline__container__list-items__item__subitem
                        ${getSubItemClass(item, subitem, index, sIndex)}`,
                children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
                  className: `ccl-e-timeline__subIconContainer`,
                  children: /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
                    className: `ccl-e-timeline__subIcon ccl-e-timeline__icon__pending`
                  })
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
                  className: `ccl-e-timeline__subdot`,
                  children: ' '
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("p", {
                  className: "ccl-e-timeline__item-note",
                  children: labels[subitem == null ? void 0 : subitem.label]
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_Badge.default, {
                  children: formattedDate(data == null ? void 0 : data.date[subitem.id])
                })]
              }, subitem.id || sIndex);
            }))
          })]
        }, item.id || index);
      })
    })
  });
};
exports.Timeline = Timeline;
Timeline.defaultProps = {};